var _defs, _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFifteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #e5e5e5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M942.94,413.7v401.35c0,50.17-40.66,90.85-90.83,90.85H211.39c-50.17,0-90.84-40.67-90.84-90.84h0v-401.36h822.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M966.14,550.11c-295.65,95.41-585.18,93.51-868.97.08-11.75-3.88-19.69-14.86-19.68-27.24V241.5c0-12.59,10.21-22.8,22.8-22.8h862.91c12.59,0,22.8,10.21,22.8,22.8v281.31c0,12.44-8.02,23.47-19.86,27.3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 441.82,
    y: 573.51,
    width: 179.85,
    height: 85.29,
    rx: 17.09,
    ry: 17.09
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M348.36,253.47v-47.45c0-27.06,21.94-49,49-49h268.75c27.06,0,49,21.94,49,49h0v47.45c0,8.11,6.57,14.68,14.68,14.68h0c8.11,0,14.68-6.57,14.68-14.68h0v-47.46c0-43.28-35.08-78.37-78.36-78.38h-268.76c-43.28,0-78.37,35.08-78.38,78.36h0v47.47c0,8.11,6.57,14.68,14.68,14.68h0c8.11,0,14.69-6.56,14.69-14.67h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifteen);
export default __webpack_public_path__ + "static/media/fifteen.61c5b2edeec07bcc2eddedaa33f0d2a5.svg";
export { ForwardRef as ReactComponent };